export const DEFAULT_MONGO_DB_YEAR = 2021;
